import { actions, paths } from "../../../../common/constants";

export default {
  getDashboardData: () => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_DASHBOARD_DATA_REQUEST,
        actions.GET_DASHBOARD_DATA_SUCCESS,
        actions.GET_DASHBOARD_DATA_FAILURE,
      ],
      promise: (client) => client.get(paths.api.v1.GET_DASHBOARD_DATA),
    },
  }),

  getTransactionGraph: ({ transaction_range, transaction_date }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_TRANSACTION_GRAPH_REQUEST,
        actions.GET_TRANSACTION_GRAPH_SUCCESS,
        actions.GET_TRANSACTION_GRAPH_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.GET_TRANSACTION_GRAPH, {
          params: { transaction_range, transaction_date },
        }),
    },
  }),

  getPostGraph: ({ post_range, post_date }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POST_GRAPH_REQUEST,
        actions.GET_POST_GRAPH_SUCCESS,
        actions.GET_POST_GRAPH_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.GET_POST_GRAPH, {
          params: { post_range, post_date },
        }),
    },
  }),

  getUploadGraph: ({ upload_range, upload_date }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_UPLOAD_GRAPH_REQUEST,
        actions.GET_UPLOAD_GRAPH_SUCCESS,
        actions.GET_UPLOAD_GRAPH_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.GET_UPLOAD_GRAPH, {
          params: { upload_range, upload_date },
        }),
    },
  }),

  getReportData: ({
    app_downloads_range,
    app_shares_range,
    revenue_range,
  }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_REPORT_DATA_REQUEST,
        actions.GET_REPORT_DATA_SUCCESS,
        actions.GET_REPORT_DATA_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.build(paths.api.v1.GET_REPORT_DATA), {
          app_downloads_range,
          app_shares_range,
          revenue_range,
        }),
    },
  }),

  getActivityUsers: ({ activity_users_range, activity_users_date }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_ACTIVITY_USERS_REQUEST,
        actions.GET_ACTIVITY_USERS_SUCCESS,
        actions.GET_ACTIVITY_USERS_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.GET_ACTIVITY_USERS, {
          params: { activity_users_range, activity_users_date },
        }),
    },
  }),

  getRevenueGraph: ({ revenue_range, revenue_date }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_REVENUE_GRAPH_REQUEST,
        actions.GET_REVENUE_GRAPH_SUCCESS,
        actions.GET_REVENUE_GRAPH_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.GET_REVENUE_DATA, {
          params: { revenue_range, revenue_date },
        }),
    },
  }),

  getNumericReport: ({ numeric_report_date }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_NUMERIC_REPORT_REQUEST,
        actions.GET_NUMERIC_REPORT_SUCCESS,
        actions.GET_NUMERIC_REPORT_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.GET_NUMERIC_REPORT, {
          params: { numeric_report_date },
        }),
    },
  }),
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/dashboard.js